<div
  [ngClass]="['app-form-label--' + verticalAlign]"
  class="app-form-label"
>
  <div class="app-form-label__container">
    <label
      [class.app-form-label__label--disabled]="isLabelDisabled"
      [ngClass]="['app-form-label__label--' + orientation]"
      class="app-form-label__label"
    >
      <ng-content select=".app-form-label-content"></ng-content>
      <span
        *ngIf="text"
        [qimaAutoTooltipHasArrow]="true"
        [qimaAutoTooltipPosition]="qimaTooltip.position.TOP_LEFT"
        [qimaAutoTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
        [qimaAutoTooltipStyle]="qimaTooltip.style.DARK"
        [qimaAutoTooltipText]="text | translate"
        class="text"
        qimaAutoTooltip
        >{{ text | translate }}</span
      >
      <span
        *ngIf="isOptional"
        class="optional"
      >
        ({{ 'COMMON.OPTIONAL' | translate }})
      </span>
    </label>
    <div class="app-form-label__required">
      <span
        *ngIf="isRequired"
        class="required-text"
        >*</span
      >
    </div>
    <div class="app-form-label__icon">
      <qima-icon
        *ngIf="tooltipLabel"
        [qimaIconName]="infoIconName"
        [qimaIconSize]="qimaIcon.sizeMedium"
        [qimaTooltipHasArrow]="true"
        [qimaTooltipPosition]="tooltipPosition"
        [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
        [qimaTooltipStyle]="qimaTooltip.style.DARK"
        [qimaTooltipTemplate]="customTemplate"
        class="info-icon"
        qimaTooltip
      ></qima-icon>
    </div>
  </div>
</div>

<ng-template #customTemplate>
  <div
    *ngIf="tooltipLabel"
    [innerHTML]="tooltipLabel | translate"
  ></div>
</ng-template>
